import { CultureInfo } from '../culture-info.model';
import { CultureInfoSrCyrl } from './sr-Cyrl';

/**
 * @ignore
 */
export const CultureInfoSrCyrlBA: CultureInfo = {
  name: 'sr-Cyrl-BA',
  displayName: 'Serbian (Cyrillic, Bosnia & Herzegovina)',
  iso3LanguageCode: 'srp',
  iso2LanguageCode: 'sr',
  ietfLanguageTag: 'sr-Cyrl-BA',
  parent: CultureInfoSrCyrl
};
